import { DefaultError } from './errors'

const isFreezeable = (value: any) => {
	if (Array.isArray(value) && Object.getPrototypeOf(value) === Array.prototype) return true
	if (value && typeof value === 'object' && Object.getPrototypeOf(value) === Object.prototype && !value.$$typeof)
		return true
	return false
}

const maxDepth = 50

/**
 * Freeze object/array and all decendants. Only freezes plain objects and
 * arrays, so anything like a react element, DOM node, Date etc will not be
 * frozen.
 *
 * Handles circular references by throwing after reaching a depth of 50.
 */
export const deepFreeze = <T>(value: T): Readonly<T> => deepFreezeInternal(value, 0)

const deepFreezeInternal = (value: any, depth: number) => {
	if (depth > maxDepth) {
		throw new DefaultError(`Deep freeze max depth (${maxDepth}) exceeded, likely due to circular references`)
	}

	if (!isFreezeable(value)) return value

	const propNames = Reflect.ownKeys(value)

	// Freeze properties before freezing self
	for (const name of propNames) {
		deepFreeze(value[name])
	}

	return Object.freeze(value)
}
